<template>
  <div class="questions px-2 pt-3" id="questions">
    <three-dots class="dots mt-5" />
    <div class="title">Часто задаваемые вопросы</div>
    <div role="tablist">
      <b-card no-body class="mb-1">
        <b-card-header header-tag="header" class="p-1" role="tab">
          <b-button  class="pl-2"  block v-b-toggle.accordion-1 variant="info">Что нужно, чтобы записаться на консультацию?</b-button>
        </b-card-header>
        <b-collapse id="accordion-1" visible accordion="my-accordion" role="tabpanel">
          <b-card-body>
            <b-card-text>Заполните форму, для того чтобы я понимала что вы намерены пройти консультацию. Опишите свою проблему.
              Время встречи согласовывается и назначается только после оплаты. Из-за высокой загруженности мой график расписан на несколько дней вперед, учитывайте это при заявке.</b-card-text>
          </b-card-body>
        </b-collapse>
      </b-card>

      <b-card no-body class="mb-1">
        <b-card-header header-tag="header" class="p-1" role="tab">
          <b-button  class="pl-2"  block v-b-toggle.accordion-2 variant="info">Могут ли близкие заходить в мою комнату во время сеанса по скайпу?</b-button>
        </b-card-header>
        <b-collapse id="accordion-2" accordion="my-accordion" role="tabpanel">
          <b-card-body>
            <b-card-text>Чтобы консультация прошла успешно, вам необходимо находиться одному в комнате, организовать удобное и безопасное пространство и надеть наушники. Важно, чтобы вы чувствовали уверенность, что во время консультации никто вас не потревожит: попросите родных следить за детьми и животными, отключите звук в телефоне. Необходимо создать доверительную атмосферу между вами и психологом: третьему не место на индивидуальной консультации.</b-card-text>
          </b-card-body>
        </b-collapse>
      </b-card>

      <b-card no-body class="mb-1">
        <b-card-header header-tag="header" class="p-1" role="tab">
          <b-button class="pl-2" block v-b-toggle.accordion-3 variant="info">Могу ли я звонить психологу вне консультаций?</b-button>
        </b-card-header>
        <b-collapse id="accordion-3" accordion="my-accordion" role="tabpanel">
          <b-card-body>
            <b-card-text>Нет. Заявка на консультацию и дальнейшая связь между сеансами осуществляется только по переписке. Я против незапланированного вторжения и в равной мере уважаю личные границы клиентов.</b-card-text>
          </b-card-body>
        </b-collapse>
      </b-card>

      <b-card no-body class="mb-1">
        <b-card-header header-tag="header" class="p-1" role="tab">
          <b-button  class="pl-2"  block v-b-toggle.accordion-4 variant="info">Могу ли я писать психологу между сеансами?</b-button>
        </b-card-header>
        <b-collapse id="accordion-4" accordion="my-accordion" role="tabpanel">
          <b-card-body>
            <b-card-text>Да. Вы можете присылать мне выполненные самостоятельные задания,  делиться пережитыми чувствами. При подготовке к очередному сеансу с вами я всё прочитаю, и мы сможем обсудить это на сессии.</b-card-text>
          </b-card-body>
        </b-collapse>
      </b-card>

      <b-card no-body class="mb-1">
        <b-card-header header-tag="header" class="p-1" role="tab">
          <b-button  class="pl-2"  block v-b-toggle.accordion-5 variant="info">Можно прислать на консультацию своего супруга, чтобы он изменился?</b-button>
        </b-card-header>
        <b-collapse id="accordion-5" accordion="my-accordion" role="tabpanel">
          <b-card-body>
            <b-card-text>Выбор психолога – очень деликатный вопрос. Лучше, если ваш партнер сделает самостоятельный выбор специалиста без давления со стороны. Если вы испытали доверие ко мне и считаете, что я могу повлиять на вашего партнера, то это – ваши чувства и показатель вашего доверия ко мне. Благодаря возникшему пониманию у вас со мной может сложиться замечательный рабочий альянс, и вы достигнете эффективных изменений, которые, несомненно, отразятся на ваших взаимоотношениях с партнером и могут послужить для него стимулом к собственным изменениям.</b-card-text>
          </b-card-body>
        </b-collapse>
      </b-card>

      <b-card no-body class="mb-1">
        <b-card-header header-tag="header" class="p-1" role="tab">
          <b-button  class="pl-2"  block v-b-toggle.accordion-6 variant="info">Могу ли я доверять психологу?</b-button>
        </b-card-header>
        <b-collapse id="accordion-6" accordion="my-accordion" role="tabpanel">
          <b-card-body>
            <b-card-text>Я соблюдаю профессиональный этический кодекс, который гласит: «Информация, полученная психологом в процессе работы с клиентом на основе доверительных отношений, не подлежит намеренному или случайному разглашению». Истории, которые я рассказываю в своих статьях и видеороликах на ютуб канале – все до единого вымышлены или взяты из научной литературы. Я не имею права нигде ссылаться на сотрудничество с вами. В случае обнаружения общих знакомых я скрою, что знаю вас и не проявлю попытки к общению без вашего первого шага. Я делаю все от меня зависящее, чтобы сохранять рабочие отношения и не соприкасаться с клиентами вне рамок консультирования.</b-card-text>
          </b-card-body>
        </b-collapse>
      </b-card>

      <b-card no-body class="mb-1">
        <b-card-header header-tag="header" class="p-1" role="tab">
          <b-button  class="pl-2"  block v-b-toggle.accordion-7 variant="info">Что делать, если стыдно рассказывать о некоторых моментах - вдруг психолог плохо обо мне подумает?</b-button>
        </b-card-header>
        <b-collapse id="accordion-7" accordion="my-accordion" role="tabpanel">
          <b-card-body>
            <b-card-text>Я намерена обеспечить вам надежное контейнирование чувств. Я готова к нахлынувшим на вас воспоминаниям и собираюсь проявить устойчивость и поддержать вас. Вам стоит помнить: консультация оплачена вами, и время сеанса находится в вашем распоряжении – используйте его максимально. Психолог – не подруга, поэтому я не разочаруюсь,  не удивлюсь, а выдержу проявление вашей теневой стороны.  Как доктор спокойно относится к непривлекательным изъянам, так и я свободна от оценки и осуждения.</b-card-text>
          </b-card-body>
        </b-collapse>
      </b-card>
    </div>
  </div>
</template>

<script>
  import ThreeDots from '@/components/icons/ThreeDots';
  export default {
    name: "Questions",
    components: {ThreeDots}
  }
</script>

<style lang="scss">
  .questions {
    max-width: 720px;
    font-family: 'Raleway', sans-serif;
    margin-left: auto;
    margin-right: auto;
    display: block;
    .title {
      margin-bottom: 64px;
    }
    .btn-info:hover {
      background: #e8f4ff;
      color: #5ec8f5;
      border-color: #e8f4ff;
    }
    .btn-info:focus {
      background: #e8f4ff;
      color: #5ec8f5;
      box-shadow: none;
      border-color: #e8f4ff;
    }
    .btn-info:visited {
      background: #e8f4ff;
      color: #5ec8f5;
      box-shadow: none;
      border-color: #e8f4ff;
    }
    .btn-info:active {
      background: #e8f4ff;
      color: #5ec8f5;
      box-shadow: none;
      border-color: #e8f4ff;
    }
    .btn-info:link {
      background: #e8f4ff;
      color: #5ec8f5;
      box-shadow: none;
      border-color: #e8f4ff;
    }
    .btn-info {
      background: #e8f4ff;
      border-color: #e8f4ff;
      color: #5ec8f5;
      text-align: left;
    }
    .btn-info.collapsed {
      color: #1f1f1f;
    }
    .btn-info.collapsed:hover {
      color: #1f1f1f;
    }
    .card-header {
      background: #fff;
      border: none !important;
      position: relative;
    }
    .card-text {
      color: #7e7e7e;
    }
    .card-header {
      .btn-info {
        padding-right: 30px;
      }
      .btn-info:after {
        position: absolute;
        top: 50%;
        margin-top: -12px;
        right: 19px;
        content: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='13' height='13' fill='none' viewBox='0 0 13 13'%3E%3Cpath fill='%235EC8F5' d='M.2 6.2H12.202l-6 6-6-6z'/%3E%3C/svg%3E%0A");
      }
      .collapsed.btn-info:after {
        content: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='13' height='13' fill='none' viewBox='0 0 13 13'%3E%3Cpath fill='%231f1f1f' d='M.2 6.2H12.202l-6 6-6-6z'/%3E%3C/svg%3E%0A");
      }
    }
    .card {
      border: none !important;
    }
  }
  .btn-info:not(:disabled):not(.disabled):active,
  .btn-info:not(:disabled):not(.disabled).active,
  .show > .btn-info.dropdown-toggle {
    background: #e8f4ff !important;
    color: #5ec8f5 !important;
    border-color: #e8f4ff !important;
  }
  .btn-info:not(:disabled):not(.disabled):active:focus
  .btn-info:not(:disabled):not(.disabled).active:focus,
  .show > .btn-info.dropdown-toggle:focus {
    box-shadow: none !important;
  }
  @media screen and (max-width: 550px){
    .questions {
      .title {
        margin-bottom: 32px;
      }
    }
  }
</style>